import React from 'react'
import { Box } from '@usap/uicomponents'
import { commaSeparetedValue } from '@usap/core'
import { SummaryDarkerItem } from '../SummaryWmo.css'

const ShippingWmo = props => {
  const { data, multiShippingDiscountFlag } = props
  const estWeight = parseFloat(data.shipping.estimated) > 0 ? 'normal' : 'bold'
  const costWeight = parseFloat(data.shipping.cost) > 0 ? 'normal' : 'bold'
  return (
    <Box direction="row" justify="between">
      <SummaryDarkerItem>
        Est. Shipping:
      </SummaryDarkerItem>

      {multiShippingDiscountFlag
        ? (
          <SummaryDarkerItem weight={costWeight} data-testid='cart-summary-shipping'>
            {parseFloat(data.shipping.cost) > 0 ? `$${commaSeparetedValue(parseFloat(data.shipping.cost))}` : 'FREE'}
          </SummaryDarkerItem>
        )
        : (
          <SummaryDarkerItem weight={estWeight} data-testid='cart-summary-shipping'>
            {parseFloat(data.shipping.estimated) > 0 ? `$${commaSeparetedValue(parseFloat(data.shipping.estimated))}` : 'FREE'}
          </SummaryDarkerItem>
        )}
    </Box>
  )
}

export default ShippingWmo
